import Router from 'vue-router'
import qs from 'qs'
import NotFound from '@/components/site/NotFound'
import { get } from 'lodash'

import VuetifyStyle from 'vuetify/dist/vuetify.min.css'

/**
 * @var VueX.Store the injected store service
 */
let _store

/**
 * @var the injected auth service
 */
let _auth

const router = new Router({
  mode: 'history', // prevents hash in url
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "Home" */ '../components/site/Home.vue'),
      props: true
    },
    {
      // Root only. Accepts the browser's filters as query parameters
      // (user_id, customer_id, method, endpoint, created_after,
      // created_before) so another view can link into a pre-filtered browser.
      path: '/api-requests',
      name: 'api-access-log-index',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "ApiAccessLogIndex" */ '../components/api-access-log/ApiAccessLogIndex.vue'),
      props: true
    },
    {
      // Root only. Aggregates over the same table as /api-requests, and links
      // into it: every figure on the page is a drill-down that carries the
      // entity plus both date bounds.
      path: '/api-usage',
      name: 'api-access-log-statistics-index',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "ApiAccessLogStatisticsIndex" */ '../components/api-access-log/ApiAccessLogStatisticsIndex.vue'),
      props: true
    },
    {
      path: '/audit-logs',
      name: 'audit-log-index',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "AuditLogIndex" */ '../components/audit-log/AuditLogIndex.vue'),
      props: true
    },
    {
      path: '/banners',
      name: 'banner-index',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "BannerIndex" */ '../components/banner/BannerIndex.vue'),
      props: true
    },
    {
      path: '/banner/create',
      name: 'banner-create',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "BannerCreate" */ '../components/banner/BannerCreate.vue'),
      props: true
    },
    {
      path: '/banner/update/:id',
      name: 'banner-update',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "BannerUpdate" */ '../components/banner/BannerUpdate.vue'),
      props: true
    },
    {
      path: '/customers',
      name: 'customer-index',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "CustomerIndex" */ '../components/customer/CustomerIndex.vue'),
      props: true
    },
    {
      path: '/customer/create',
      name: 'customer-create',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "CustomerCreate" */ '../components/customer/CustomerCreate.vue'),
      props: true
    },
    {
      path: '/customer/:id',
      name: 'customer-update',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "CustomerUpdate" */ '../components/customer/CustomerUpdate.vue'),
      props: true
    },
    {
      path: '/fleet-health',
      name: 'fleet-health',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "FleetHealth" */ '../components/fleet-health/FleetHealth.vue'),
      props: true,
      alias: '/insights-dashboard'
    },
    {
      path: '/location/create',
      name: 'location-create',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "LocationCreate" */ '../components/location/LocationCreate.vue'),
      props: true
    },
    {
      path: '/location/map',
      name: 'location-map',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "LocationMap" */ '../components/location/LocationMap.vue'),
      props: true
    },
    {
      path: '/locations/unregistered',
      name: 'locations-unregistered',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "UnregisteredLocations" */ '../components/location/UnregisteredLocations.vue'),
      props: true
    },
    {
      path: '/location/:id',
      alias: ['/location/update/:id'],
      name: 'location-update',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "LocationUpdate" */ '../components/location/LocationUpdate.vue'),
      props: true
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        authRequired: false,
        layout: 'empty'
      },
      component: () => import(/* webpackChunkName: "Login" */ '../components/site/Login.vue'),
      props: true
    },
    {
      path: '/tv',
      name: 'TV login',
      meta: {
        authRequired: false,
        layout: 'empty'
      },
      component: () => import(/* webpackChunkName: "Login" */ '../components/site/TvLogin.vue'),
      props: true
    },
    {
      path: '/product/start-temps',
      name: 'product-start-temps',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "ProductStartTemps" */ '../components/product/ProductStartTemps.vue'),
      props: true
    },
    // {
      // path: '/product/curve-match2',
      // name: 'product-curve-match',
      // component: () => import(/* webpackChunkName: "ProductCurveMatch" */ '../components/old-ui/product/ProductCurveMatch.vue'),
      // props: true
    // },
    {
      path: '/products',
      name: 'product-index',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "ProductsIndex" */ '../components/product/ProductsIndex.vue'),
      props: true
    },
    {
      path: '/product/create',
      name: 'product-create',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "ProductCreate" */ '../components/product/ProductCreate.vue'),
      props: true
    },
    {
      path: '/product/:id',
      name: 'product-view',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "ProductView" */ '../components/product/ProductView.vue'),
      props: true
    },
    {
      path: '/product/update/:id',
      name: 'product-update',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "ProductUpdate" */ '../components/product/ProductUpdate.vue'),
      props: true
    },
    {
      path: '/vehicles',
      name: 'vehicle-index',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "VehicleIndex" */ '../components/vehicle/VehicleIndex.vue'),
      props: true
    },
    {
      path: '/vehicle/map',
      name: 'vehicle-map',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "VehicleMap" */ '../components/vehicle/VehicleMap.vue'),
      props: true
    },
    {
      path: '/vehicle/:id',
      name: 'vehicle-view',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "VehicleView" */ '../components/vehicle/VehicleView.vue'),
      props: true
    },
    {
      path: '/reset-client',
      name: 'reset-client',
      meta: {
        authRequired: false,
        layout: 'empty'
      },
      component: () => import(/* webpackChunkName: "ResetClient" */ '../components/site/ResetClient.vue'),
      props: true
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      meta: {
        authRequired: false,
        layout: 'empty'
      },
      component: () => import(/* webpackChunkName: "ResetPassword" */ '../components/site/ResetPassword.vue'),
      props: true
    },
    {
      path: '/login-display',
      name: 'login-display',
      meta: {
        authRequired: false,
        layout: 'empty'
      },
      component: () => import(/* webpackChunkName: "ResetPassword" */ '../components/site/LoginDisplay.vue'),
      props: true
    },
    {
      path: '/root-cause/index',
      name: 'root-cause-list',
      alias: ['/route/root-cause-list'],
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "RootCauseIndex" */ '../components/root-cause/RootCauseIndex.vue'),
      props: true
    },
    {
      path: '/root-causes',
      name: 'root-causes',
      alias: ['/route/root-causes'],
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "RootCauseAnalysis" */ '../components/root-cause/RootCauseAnalysis.vue'),
      props: true
    },
    {
      path: '/root-cause/:id',
      name: 'root-cause-view',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "RootCauseView" */ '../components/root-cause/RootCauseView.vue'),
      props: true
    },
    {
      path: '/route/index',
      alias: ['/route/list', '/route/archive'],
      name: 'route-index',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "RouteIndex" */ '../components/route/RouteIndex.vue'),
      props: true
    },
    {
      path: '/routes',
      alias: ['/routes/dashboard', '/route/index'],
      name: 'route-dashboard',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "RouteDashboard" */ '../components/route/RouteDashboard.vue'),
      props: true
    },
    {
      path: '/route/create/:planid?',
      name: 'route-create',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "RouteCreate" */ '../components/route/RouteCreate.vue'),
      props: true
    },
    {
      path: '/route/update/:id',
      name: 'route-update',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "RouteUpdate" */ '../components/route/RouteUpdate.vue'),
      props: true
    },
    {
      path: '/route/upload',
      name: 'route-upload',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "RouteUpload" */ '../components/route/RouteUpload.vue'),
      props: true
    },
    {
      path: '/route/:id',
      name: 'route-view',
      alias: ['/route/view/:id'],
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "RouteView" */ '../components/route/RouteView.vue'),
      props: true
    },
    {
      path: '/route-plans/',
      name: 'route-plan-index',
      alias: ['/route-plan/index'],
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "RoutePlanIndex" */ '../components/route-plan/RoutePlanIndex.vue'),
      props: true
    },
    {
      path: '/route-plan/:id',
      name: 'route-plan-view',
      alias: ['/route-plan/view/:id'],
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "RoutePlanView" */ '../components/route-plan/RoutePlanView.vue'),
      props: true
    },
    {
      path: '/route-plans/excluded',
      name: 'route-plan-exclude-index',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "RoutePlanExcludeIndex" */ '../components/route-plan/RoutePlanExcludeIndex.vue'),
      props: true
    },
    {
      path: '/route-plans/file-upload-history',
      name: 'route-plan-file-upload-history',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "RoutePlanFileUploadHistory" */ '../views/RoutePlanFileUploadHistory.vue'),
      props: true
    },
    {
      path: '/locations/index',
      name: 'location-index',
      alias: ['/locations'],
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "LocationIndex" */ '../components/location/LocationIndex.vue'),
      props: true
    },
    {
      path: '/users',
      name: 'user-index',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "UserIndex" */ '../components/user/UserIndex.vue'),
      props: true
    },
    {
      path: '/user/bulk-create',
      alias: ['/user/new'],
      name: 'bulk-user-create',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "BulkUserCreate" */ '../components/user/BulkUserCreate.vue'),
      props: true
    },
    {
      path: '/user/create',
      name: 'user-create',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "UserCreate" */ '../components/user/UserCreate.vue'),
      props: true
    },
    {
      path: '/user/notifications',
      name: 'notifications',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "NotificationRules" */ '../components/notification/NotificationRules.vue'),
      props: true
    },
    {
      path: '/user/settings',
      name: 'user-settings',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "UserSettings" */ '../components/user/UserSettings.vue'),
      props: true
    },
    {
      path: '/user/update/:id',
      name: 'user-update',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "UserUpdate" */ '../components/user/UserUpdate.vue'),
      props: true
    },
    {
      path: '/welcome',
      name: 'welcome',
      meta: {
        authRequired: false,
        layout: 'empty'
      },
      component: () => import(/* webpackChunkName: "Welcome" */ '../components/site/Welcome.vue'),
      props: true
    },
    {
      path: '/energy-price-sets',
      name: 'energy-price-set-index',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "EnergyPriceSetIndex" */ '../components/energy/EnergyPriceSetIndex.vue'),
      props: true
    },
    {
      path: '/energy-price-set/create',
      name: 'energy-price-set-create',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "EnergyPriceSetCreate" */ '../components/energy/EnergyPriceSetCreate.vue'),
      props: true
    },
    {
      path: '/energy-price-set/:id',
      name: 'energy-price-set-update',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "EnergyPriceSetUpdate" */ '../components/energy/EnergyPriceSetUpdate.vue'),
      props: true
    },
    {
      path: '/reports',
      alias: ['/report/index'],
      name: 'report-dashboard',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "ReportDashboard" */ '../components/report/ReportDashboard.vue'),
      props: true
    },
    {
      path: '/report/:id',
      name: 'report-view',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "ReportView" */ '../components/report/ReportView.vue'),
      props: true
    },
    {
      path: '/metrics/telemetry-provider-status',
      name: 'telemetry-provider-status',
      alias: ['/service-data/data-pull'],
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "TelemetryProviderStatus" */ '../components/metrics/TelemetryProviderStatus.vue'),
      props: true
    },
    {
      path: '/metrics/queue-status',
      name: 'queue-status',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "QueueStatus" */ '../components/metrics/QueueStatus.vue'),
      props: true
    },
    {
      path: '/invoices',
      name: 'invoice-index',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "InvoiceIndex" */ '../components/invoice/InvoiceIndex.vue'),
      props: true
    },
    {
      path: '/performance/dashboard',
      name: 'performance-dashboard',
      alias: ['/system-dashboard', '/performance-dashboard', '/performance'],
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "PerformanceDashboard" */ '../components/performance-dashboard/PerformanceDashboard.vue'),
      props: true
    },
    {
      path: '/performance/dashboard/customers/:customerIds',
      name: 'performance-dashboard-with-customer-ids',
      alias: ['/system-dashboard/customers/:customerIds', '/performance-dashboard/customers/:customerIds'],
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "PerformanceDashboard" */ '../components/performance-dashboard/PerformanceDashboard.vue'),
      props: true
    },
    {
      path: '/sustainability',
      name: 'sustainability',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "SustainabilityDashboard" */ '../components/sustainability/dashboard/SustainabilityDashboard.vue'),
      props: true
    },
    // {
    //   path: '/extended-route-staging',
    //   name: 'extended-route-staging',
    //   component: () => import(/* webpackChunkName: "ExtendedStagingIndex" */ '../components/extended-staging/ExtendedStagingIndex.vue'),
    //   props: true
    // },
    {
      path: '/sustainability/customers/:customerIds',
      name: 'sustainability-with-customer-ids',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "SustainabilityDashboard" */ '../components/sustainability/dashboard/SustainabilityDashboard.vue'),
      props: true
    },
    {
      path: '/sustainability/enroute',
      name: 'sustainability-enroute',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "EnrouteReeferActivityIndex" */ '../components/sustainability/EnrouteReeferActivityIndex.vue'),
      props: true
    },
    {
      path: '/sustainability/staging',
      name: 'sustainability-staging',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "StagingReeferActivityIndex" */ '../components/sustainability/StagingReeferActivityIndex.vue'),
      props: true
    },
    {
      path: '/sustainability/vehicles',
      name: 'sustainability-vehicles',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "HighReeferActivityVehicles" */ '../components/sustainability/HighReeferActivityVehicles.vue'),
      props: true
    },
    {
      path: '/404',
      name: '404',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "NotFound" */ '../components/site/NotFound.vue'),
      props: true
    },
    {
      path: '/:catchAll(.*)',
      name: 'not-found',
      meta: {
        switchableUI: true
      },
      component: () => import(/* webpackChunkName: "NotFound" */ '../components/site/NotFound.vue'),
      props: true
    }
  ],

  /**
   * Set custom query resolver. In particular to support array style parameters
   * (with brackets) in the query string
   *
   * @return object
   * @see qs.parse()
   */
  parseQuery (query) {
    return qs.parse(query)
  },

  /**
   * Takes an object and converts it to an HTTP query string
   *
   * @param Object query
   * @return string
   * @see qs.stringify()
   */
  stringifyQuery (query) {
    var result = qs.stringify(query)
    return result ? ('?' + result) : ''
  }
})

router.beforeEach((to, from, next) => {
  // Clear all flash alerts
  _store.dispatch('globalMessagingModule/clearFlashBanners')
  // Clear all notification alerts
  _store.dispatch('globalMessagingModule/clearNotifications')

  // Reset the maintenance modal state
  _store.dispatch('globalMessagingModule/setMaintenanceMode', false)

  const validJwt = _auth.jwtTimeIsValid()
  const authRequired = get(to, 'meta.authRequired', true)

  // If user is not logged in and auth is required on the route, go to login page
  if (!validJwt && authRequired) {
    _store.dispatch('userModule/setReturnUrl', to.path)
    return next('/login')
  }

  // Set the desired layout from the route's metadata. If no layout found, use the default layout.
  const layout = get(to, 'meta.layout', 'default')
  VuetifyStyle.use()
  _store.dispatch('layoutModule/setLayout', layout)

  return next()
})

/**
 * Install the module.
 * @param Vue
 * @param options
 * @param store
 * @param auth
 */
router.install = (Vue, options, store, auth) => {
  _store = store
  _auth = auth
  // Invoke Vue router install, this will set up $router
  Router.install(Vue, options)
}

export default router
